import { GoogleSheetsSyncPage, SyncType } from '../../components/GoogleSheetsSyncPage/GoogleSheetsSyncPage';
import { PageId } from '../../components/Sidebar/Sidebar';
import defaultSheets from '../../config/default_sheets';

const DateMappingSyncPage = () => {
  return (
    <GoogleSheetsSyncPage
      title="Sync Date Mapping Data from Google Sheets"
      syncType={SyncType.DateMapping}
      pageId={PageId.DateMapping}
      defaultSheetUrl={defaultSheets.DateMapping.defaultSheetUrl}
      defaultRange={defaultSheets.DateMapping.defaultRange}
    />
  );
};

export default DateMappingSyncPage;
